import {
  OverviewTotalVehiclesResponse,
  OverviewMonthlyExpiringResponse,
  MonthlyCount,
  OverviewRevenueExpenseResponse,
  MonthlyRevenueExpense,
  OverviewOffersResponse,
  MonthlyOffers,
  OverviewInvoicesResponse,
  MonthlyInvoices,
  OverviewInquiriesResponse,
  VehicleAlertRow,
  VehicleAlertType,
  VehicleAlertStatus,
  VehicleProfitabilityRow,
} from "./types";

/*---------------------------------------------------------------------------------------
  OVERVIEW — TOTAL VEHICLES
-----------------------------------------------------------------------------------------*/

export const transformOverviewTotalVehicles = (res: any): OverviewTotalVehiclesResponse => ({
  total: res.total ?? 0,
  newVehicles: res.newVehicles ?? 0,
  usedVehicles: res.usedVehicles ?? 0,
  newChange: res.newChange ?? 0,
  usedChange: res.usedChange ?? 0,
  avgPurchasePrice: res.avgPurchasePrice ?? 0,
  soldThisMonth: res.soldThisMonth ?? 0,
});

/*---------------------------------------------------------------------------------------
  OVERVIEW — MONTHLY EXPIRING (registracija, osiguranje, vatrogasni)
-----------------------------------------------------------------------------------------*/

export const transformOverviewMonthlyExpiring = (res: any): OverviewMonthlyExpiringResponse => ({
  total: res.total ?? 0,
  months: (res.months ?? []).map(transformMonthlyCount),
});

const transformMonthlyCount = (res: any): MonthlyCount => ({
  month: res.month ?? "",
  count: res.count ?? 0,
});

/*---------------------------------------------------------------------------------------
  OVERVIEW — REVENUE/EXPENSE
-----------------------------------------------------------------------------------------*/

export const transformOverviewRevenueExpense = (res: any): OverviewRevenueExpenseResponse => ({
  totalRevenue: res.totalRevenue ?? 0,
  totalExpense: res.totalExpense ?? 0,
  profit: res.profit ?? 0,
  marginPercent: res.marginPercent ?? 0,
  months: (res.months ?? []).map(transformMonthlyRevenueExpense),
});

const transformMonthlyRevenueExpense = (res: any): MonthlyRevenueExpense => ({
  month: res.month ?? "",
  monthLabel: res.monthLabel ?? "",
  start: res.start ?? null,
  end: res.end ?? null,
  revenue: res.revenue ?? 0,
  expense: res.expense ?? 0,
});

/*---------------------------------------------------------------------------------------
  OVERVIEW — OFFERS
-----------------------------------------------------------------------------------------*/

export const transformOverviewOffers = (res: any): OverviewOffersResponse => ({
  totalSent: res.totalSent ?? 0,
  totalAccepted: res.totalAccepted ?? 0,
  totalPaid: res.totalPaid ?? 0,
  months: (res.months ?? []).map(transformMonthlyOffers),
});

const transformMonthlyOffers = (res: any): MonthlyOffers => ({
  month: res.month ?? "",
  monthLabel: res.monthLabel ?? "",
  start: res.start ?? null,
  end: res.end ?? null,
  sent: res.sent ?? 0,
  accepted: res.accepted ?? 0,
  paid: res.paid ?? 0,
});

/*---------------------------------------------------------------------------------------
  OVERVIEW — INVOICES
-----------------------------------------------------------------------------------------*/

export const transformOverviewInvoices = (res: any): OverviewInvoicesResponse => ({
  totalIncomingCount: res.totalIncomingCount ?? 0,
  totalOutgoingCount: res.totalOutgoingCount ?? 0,
  totalIncomingAmount: res.totalIncomingAmount ?? 0,
  totalOutgoingAmount: res.totalOutgoingAmount ?? 0,
  avgIncomingAmount: res.avgIncomingAmount ?? 0,
  avgOutgoingAmount: res.avgOutgoingAmount ?? 0,
  oldestUnpaidDays: res.oldestUnpaidDays ?? 0,
  months: (res.months ?? []).map(transformMonthlyInvoices),
});

const transformMonthlyInvoices = (res: any): MonthlyInvoices => ({
  month: res.month ?? "",
  monthLabel: res.monthLabel ?? "",
  start: res.start ?? null,
  end: res.end ?? null,
  incomingCount: res.incomingCount ?? 0,
  outgoingCount: res.outgoingCount ?? 0,
  incomingAmount: res.incomingAmount ?? 0,
  outgoingAmount: res.outgoingAmount ?? 0,
});

/*---------------------------------------------------------------------------------------
  OVERVIEW — INQUIRIES
-----------------------------------------------------------------------------------------*/

export const transformOverviewInquiries = (res: any): OverviewInquiriesResponse => ({
  total: res.total ?? 0,
  totalOffers: res.totalOffers ?? 0,
  totalContracts: res.totalContracts ?? 0,
  months: (res.months ?? []).map(transformMonthlyCount),
});

/*---------------------------------------------------------------------------------------
  ALERTS (Upozorenja)
-----------------------------------------------------------------------------------------*/

export const transformVehicleAlertRow = (res: any): VehicleAlertRow => ({
  // Backend ne šalje id; stabilan ključ = vozilo + tip + datum (jedno vozilo može imati više aparata).
  id: `${res.vehicleId ?? ""}-${res.type ?? ""}-${res.expiryDate ?? ""}`,
  vehicleId: res.vehicleId ?? "",
  vehicleName: res.vehicleName ?? "",
  registrationPlate: res.registrationPlate ?? null,
  image: res.image || null,
  manufacturerId: res.manufacturerId ?? null,
  modelId: res.modelId ?? null,
  type: res.type as VehicleAlertType,
  expiryDate: res.expiryDate ? new Date(res.expiryDate) : null,
  daysLeft: res.daysLeft ?? 0,
  status: res.status as VehicleAlertStatus,
});

/*---------------------------------------------------------------------------------------
  FINANCIJE — profitabilnost po vozilu
-----------------------------------------------------------------------------------------*/

export const transformVehicleProfitabilityRow = (res: any): VehicleProfitabilityRow => ({
  id: res.vehicleId ?? "",
  vehicleId: res.vehicleId ?? "",
  vehicleName: res.vehicleName ?? "",
  registrationPlate: res.registrationPlate ?? null,
  image: res.image || null,
  revenue: res.revenue ?? 0,
  expense: res.expense ?? 0,
  profit: res.profit ?? 0,
  marginPercent: res.marginPercent ?? 0,
});
